module.exports = __webpack_public_path__ + "static/media/alladin.510a638a.jpg";